import { useState, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box, Toolbar, useTheme } from '@mui/material';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import { LayoutContext } from './LayoutContext';

const drawerWidth = 240;
const collapsedWidth = 60;

const Layout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const location = useLocation();
  const theme = useTheme();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleSidebarCollapse = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  // Check if current route has sidebar content
  const hasSidebar =
    ['/', '/settings', '/dashboard'].includes(location.pathname) ||
    location.pathname.startsWith('/work') ||
    location.pathname.startsWith('/scripts') ||
    location.pathname.toLowerCase().startsWith('/history');

  const layoutContextValue = useMemo(
    () => ({
      sidebarCollapsed,
      sidebarWidth: sidebarCollapsed ? collapsedWidth : drawerWidth
    }),
    [sidebarCollapsed]
  );

  return (
    <Box
      sx={{
        display: 'flex',
        bgcolor: theme.palette.background.default,
        minHeight: '100vh',
        width: '100%',
        overflow: 'hidden'
      }}
    >
      <Navbar />
      {hasSidebar && (
        <Sidebar
          open={mobileOpen}
          onClose={handleDrawerToggle}
          drawerWidth={drawerWidth}
          collapsed={sidebarCollapsed}
          onToggleCollapse={handleSidebarCollapse}
        />
      )}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          overflow: 'hidden',
          height: '100vh',
          backgroundColor: theme.palette.background.default,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Toolbar sx={{ flexShrink: 0 }} />
        <Box
          sx={{
            flex: '1 1 auto',
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
            width: '100%'
          }}
        >
          <LayoutContext.Provider value={layoutContextValue}>
            <Outlet />
          </LayoutContext.Provider>
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
